/**
 * @voltxampere/ui — Adafruit Feather pinout variant (Sprint 47.5-2, placeholder)
 *
 * PLACEHOLDER. Adafruit Feather is a 28-pin pinout standard supporting
 * ESP32 / ATmega32U4 / nRF52 / SAMD21 variants with USB-C + LiPo
 * battery + onboard charger. Sprint 47.5 MVP renders as mcu-execution
 * with atmega328p family defaults (closest AVR placeholder); real
 * ESP32/SAMD21 emulation Sprint 49+.
 *
 * Reference: Adafruit Feather pinout standard
 * (https://learn.adafruit.com/adafruit-feather/feather-specification).
 * 16 GPIO + 4 ADC + USB-C + 2-pin LiPo JST + onboard 5V regulator.
 *
 * Engine zero-diff invariant honored — canonical `mcu-execution`.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const mcuAdafruitFeather = {
    id: "adafruit-feather",
    nameTr: "Adafruit Feather (ESP32/SAMD21, USB-C, placeholder)",
    nameEn: "Adafruit Feather (ESP32/SAMD21, USB-C, placeholder)",
    shortcut: "U",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "Feather",
    schemaType: "mcu-execution",
    defaultParams: {
        family: "atmega328p",
        clockHz: 16e6,
        flashHex: "",
        instructionsPerTick: 1000,
        vSupply: 3.3,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=mcu-adafruit-feather.js.map